
<script>import { Σ } from "../../common/clsx/index";
import { css } from "emotion";
import { fly } from "svelte/transition";
import { createEventDispatcher, onDestroy } from "svelte";
export let top = 16;
export let title = "";
export let message = "";
export let type;
let thisNotification = null;
const dispatch = createEventDispatcher();

const onClose = () => dispatch("close");

onDestroy(() => {
  const rect = thisNotification.getBoundingClientRect();
  dispatch("willUnmount", {
    height: rect.height,
    top: rect.top
  });
});
const state = {};
state.style = Σ("el-notification", css`
            top: ${top}px;
            right: 16px;
            z-index: 9999;
        `);
state.iconStyle = Σ("el-notification__icon", {
  [`el-icon-${type}`]: Boolean(type)
});
state.wrapperStyle = Σ("el-notification__group", {
  "is-with-icon": Boolean(type)
});</script>


<div bind:this={thisNotification} class={state.style} transition:fly="{{duration:500}}">
        <i class={state.iconStyle}></i>
        <div class={state.wrapperStyle}>
            <h2 class="el-notification__title">{title}</h2>
            <div class="el-notification__content">{message}</div>
            <div class="el-notification__closeBtn el-icon-close" on:click={onClose}></div>
        </div>
    </div>


<style>

</style>